<template>
    <CardRh :processando="processando" titulo="AVALIACOES">
        <div class="avaliacao-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span> 
                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaAvaliacao" class="form-label">Pesquisar</label>
                        <input id="pesquisaAvaliacao" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Aluno, disciplina ou turma" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="cpfAvaliacao" class="form-label">CPF</label>
                        <input id="cpfAvaliacao" v-model="cpf" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="CPF" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2" v-if="status">
                        <label for="statusAvaliacao" class="form-label">Status</label>
                        <Multiselect id="statusAvaliacao" @change="refreshTable" :options="status_select"
                            :searchable="true" v-model="status_id" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2" v-if="tipo">
                        <label for="tipoAvaliacao" class="form-label">Tipo</label>
                        <Multiselect id="tipoAvaliacao" @change="refreshTable" :options="tipo_select"
                            :searchable="true" v-model="tipo_id" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-1">
                        <label for="pelotaoAvaliacao" class="form-label">Pelotao</label>
                        <input id="pelotaoAvaliacao" v-model="pelotao" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pelotao" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-1">
                        <label for="notaMinAvaliacao" class="form-label">Nota Mínima</label>
                        <input id="notaMinAvaliacao" v-model="notaMin" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Nota Min" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-1">
                        <label for="notaMaxAvaliacao" class="form-label">Nota Máxima</label>
                        <input id="notaMaxAvaliacao" v-model="notaMax" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Nota Max" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="turmaAvaliacao" class="form-label">Turma</label>
                        <input id="turmaAvaliacao" v-model="turma" @keyup="apertouEnter" type="text" class="form-control form-control-solid" placeholder="Turma" />
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="disciplinaAvaliacao" class="form-label">Disciplina</label>
                        <input id="disciplinaAvaliacao" v-model="disciplina" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Disciplina" />
                    </div> 
                    <div class="col-12 col-lg-2 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm mt-5" @click="limparFiltros">
                            Limpar filtros
                        </button>
                    </div>
                </div>
            </section> 
            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th>Turma</th>
                    <th>Disciplina</th>
                    <th>Aluno</th>
                    <th>Tipo</th>
                    <th>Nota</th>
                    <th>Status</th>
                    <th style="min-width:220px" class="text-center" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import NotaService from "@/service/v1/sigap/NotaService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "AvaliacaoIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class AvaliacaoIndex extends IndexModelTable {
    public status_id: any = 1;
    public status: any = null;
    public tipo_id: any = null;
    public tipo: any = null;
    public cpf = "";
    public pelotao = "";
    public notaMin = "";
    public notaMax = "";
    public disciplina = "";
    public turma = "";
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    get tipo_select() {
        if (this.tipo) {
            return this.tipo.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public getTipo() {
        this.processando = true;
        this.service.getTipo()
            .then(response => {
                this.tipo = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.cpf = "";
        this.status_id = "";
        this.tipo_id = "";
        this.pelotao = "";
        this.notaMin = "";
        this.notaMax = "";
        this.disciplina = "";
        this.turma = "";
        this.refreshTable();
    }

    created() {
        this.service = new NotaService();
        this.getStatus();
        this.getTipo();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    cpf: this.cpf,
                    status: this.status_id,
                    tipo: this.tipo_id,
                    pelotao: this.pelotao,
                    disciplina: this.disciplina,
                    notaMax: this.notaMax,
                    notaMin: this.notaMin,
                    turma: this.turma,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[0, "asc"],[1, "asc"],[2, "asc"]];
        this.config.columns = [
            { data: "disciplina.turma.descricao", name: "turma"},
            { data: "disciplina.descricao", name: "disciplina"},
            { data: "matricula.usuario.nome", name: "aluno"},
            { data: "tipo", name: "tipo"},
            { data: "notaValor", name: "notavalor"},
            { data: "status", name: "status"},
        ];
        this.config.columnDefs = [
            {
                targets: 3,
                render: function (row) {
                    return row.nome.replaceAll("_", " ");
                }
            },
            {
                targets: 5,
                render: function (row) {
                    return row.nome.replaceAll("_", " ");
                }
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 6,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-nota ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-show-nota]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            const routeData = this.$router.resolve({ name: "sigap_avaliacao_show", params: { id: id } });
            window.open(routeData.href, "_blank");
        });
    }
}
</script>

<style scoped>
.avaliacao-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
